<style lang="less" scoped>
.delivery-phone{
  height: 60px;
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 11px 16px;
  .delivery-icon{
    height: 20px;
    width: 20px;
    margin-right: 12px;
  }
  .phone-number{
    font-size: 15px;
    color: #4a4a4a;
  }
  label{
    color: #9b9b9b;
    font-size: 13px;
  }
}
</style>

<template>
  <div class="delivery-phone">
    <img class="delivery-icon" src="../../../../image/preorder/icon.png" />
    <div>
      <div class="phone-number">{{phone}}</div>
      <label for="">订单信息将发送到该手机</label>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {

  data() {
    return {
      phone: '',
    }
  },
  mounted() {
    this.getUserInfo().then(data => {
      console.log("data",data)
      this.phone = data.mobile
    })
  },
  methods: {
    ...mapActions([
      'getUserInfo',
    ]),
  },
  watch: {
    phone(newVal) {
      this.$store.commit('setDeliveryData', {
        phone: newVal,
      })
      this.$store.commit('setMobile', newVal)
    }
  }
}
</script>
